<template>
  <div class="__scale_anatomy columns">
    <div class="column is-half">
      <div class="form">
        <p class="instruction">Click a section to show/hide on the scale image.</p>
        <div :class="[{anterior:anterior, small:small},'item']" @click="ShowHide('anterior')">
          <h4>Anterior Field</h4>
          <ul>
            <li>Portion pointed towards head of fish.</li>
            <li>Located in pocket of skin.</li>
            <li>It is not visible.</li>
            <li>Contains circuli used to estimate age.</li>
          </ul>
        </div>
        <div :class="[{posterior:posterior, small:small},'item']" @click="ShowHide('posterior')">
          <h4>Posterior Field</h4>
          <ul>
            <li>Portion pointed towards tail of fish.</li>
            <li>Exposed as fish swims.</li>
            <li>Covered with pigmented cells.</li>
            <li>Comprises visible portion of scale.</li>
            <li>When grasp scale with forceps, you pull on the posterior field.</li>
          </ul>
        </div>
        <div :class="[{focus:focus, small:small},'item']" @click="ShowHide('focus')">
          <h4>Focus</h4>
          <ul>
            <li>Point of origin of scale.</li>
            <li>Bound by first circulus.</li>
          </ul>
        </div>
        <div :class="[{margin:margin, small:small},'item']" @click="ShowHide('margin')">
          <h4>Margin</h4>
          <ul>
            <li>Border or edge of scale.</li>
            <li>Outer circumference of scale where new growth forms.</li>
          </ul>
        </div>
        <div :class="[{base:base, small:small},'item']" @click="ShowHide('base')">
          <h4>Base</h4>
          <ul>
            <li>Where posterior and anterior fields meet.</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="column is-two-thirds">
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 800 979"
        style="enable-background:new 0 0 800 979;"
        xml:space="preserve"
      >
        <g id="Scale">
          <image style="overflow:visible;" width="800" height="979" xlink:href="/img/UN0004M017.jpg" />
        </g>
        <g id="Posterior" v-show="posterior">
          <path
            d="M79.3,500.1c0,0-6,16.1-8,18.1c-2,2-12.7,14.1-14.8,16.8c-2,2.7-11.4,10.1-11.4,16.8c0,6.7,4.7,36.9,6,41.6
      c1.3,4.7,11.1,48.3,11.1,48.3S74,653.8,76,655.1c2,1.3,5.4,11.4,6.7,19.5s8,34.2,10.1,36.9c2,2.7,28.2,51,30.2,55
      c2,4,13.4,28.8,15.4,36.9c2,8,10.1,30.9,10.1,30.9l13.4,18.8c0,0,19.5,23.5,24.1,26.8c4.7,3.4,33.5,4,33.5,4s16.1,4,18.1,7.4
      c2,3.4,16.1,13.4,19.5,16.8c3.4,3.4,24.1,4,28.8,2.7s1.3-12.1,16.1-2.7c14.8,9.4,16.8,2,22.8,12.1c6,10.1,8.7,15.4,11.4,20.8
      s2.7,6,9.4,6.7c6.7,0.7,6,4,16.1-2.7c10.1-6.7,14.8-11.4,18.1-10.7c3.4,0.7,10.1,0.7,12.1,4c2,3.4,8.1,7.4,8.1,7.4s5.3,2.7,10.7,0
      c5.4-2.7,2.7-0.7,8.7-4.7s10.7-8,14.1-10.1c3.4-2,2.7-2,6.7-2.7c4-0.7,5.4,2,15.4,0c10.1-2,23.5-4.7,23.5-4.7l21.5-10.1h18.8
      c0,0,14.8-4,22.8-9.4s16.1-15.4,21.5-20.8c5.4-5.4,14.8-12.7,17.4-21.5c2.7-8.7,3.4-10.7,5.4-16.8c2-6,12.7-26.2,14.1-28.8
      s12.7-18.1,14.8-18.1c2,0,12.7-9.4,12.7-9.4l5.4-9.4c0,0-81.2-73.1-83.2-73.8c-2-0.7-65.7-61.7-65.7-61.7s-36.9-44.9-38.9-47.6
      s-44.3-35.6-52.3-38.2s-28.8-11.4-39.6-14.1s-71.1,0-75.8,0.7c-4.7,0.7-67.8-10.1-73.1-11.4s-59-26.8-59-26.8l-55.7-26.8
      L79.3,500.1z"
          />
        </g>
        <g id="Anterior" v-show="anterior">
          <path
            d="M90.1,479.4c0,0-5.4-26.2-6.7-32.2s-6.7-26.2-6.7-29.5s-2.7-26.2-3.4-32.9c-0.7-6.7-2.7-32.9-1.3-40.2
      c1.3-7.4,2.7-40.2,4.7-44.9c2-4.7,11.4-32.9,13.4-36.2s17.4-34.9,20.1-39.6c2.7-4.7,18.1-26.8,21.5-29.5s29.5-28.8,29.5-28.8
      s37.6-28.8,44.9-34.2c7.4-5.4,33.5-28.8,38.9-32.2s28.8-19.5,34.9-22.1c6-2.7,38.2-9.4,50.3-11.4c12.1-2,44.9-5.4,49-5.4
      s39.6,0,39.6,0l49.6,6c0,0,40.9,16.1,42.9,16.8s22.8,28.2,22.8,28.2l47,68.4c0,0,25.5,47,28.2,49.6s30.2,40.6,30.2,40.6
      s30.2,51.3,32.2,52.7c2,1.3,28.8,39.6,28.8,39.6l19.5,39.6l17.4,53l22.8,69.1c0,0,11.4,65.1,12.1,69.8c0.7,4.7,2,29.5,0.7,37.6
      s-3.4,27.5-8.7,35.6s-5.4,15.4-12.7,26.2c-7.4,10.7-20.1,34.2-23.5,37.6c-3.4,3.4-26.2,14.1-30.2,16.1c-4,2-39.6,22.8-41.6,23.5
      c-2,0.7-22.8,9.4-22.8,9.4s-81.2-73.1-83.2-73.8c-2-0.7-65.7-61.7-65.7-61.7s-36.9-44.9-38.9-47.6s-44.3-35.6-52.3-38.2
      s-28.8-11.4-39.6-14.1s-71.1,0-75.8,0.7c-4.7,0.7-67.8-10.1-73.1-11.4s-59-26.8-59-26.8L90.1,479.4z"
          />
        </g>
        <g id="Focus" v-show="focus">
          <path class="st2" d="M410.7,497.4c-1,1.8-3.5,1.4-4.3,1.3s-3.3-2.6-3.3-2.6l-0.4-2.7c0.4-2.6,2.4-4.8,6.4-2.2c0,0,1.8,0.9,1.9,3.2
		C411.2,496.6,410.7,497.4,410.7,497.4z"/>
          <path class="st2" d="M411.1,489.5c0,0-1.5-15.6,4.9-41.6c0.6,22.4,3.6,26.6,3.6,26.6l103.7-125l-99.2,129.6c0,0,11.3-1.2,33-6.7
            C435.3,485.8,411.1,489.5,411.1,489.5z"/>
        </g>
        <g id="Margin" v-show="margin">
          <path
            d="M639,775.9c5.4,0.7,38.2-13.4,41.6-14.8c3.4-1.3,30.2-18.1,33.5-22.1c3.4-4,26.8-34.2,28.2-37.6
      s14.1-31.5,15.4-34.9c1.3-3.4,11.4-31.5,12.1-37.6c0.7-6,2-51,0-57.7c-2-6.7-10.1-54.3-12.1-59c-2-4.7-27.5-75.1-27.5-75.1
      l-20.1-52.3c0,0-27.5-45.6-29.5-47c-2-1.3-34.9-55.7-34.9-55.7s-23.5-38.2-28.2-42.9c-4.7-4.7-24.8-35.6-24.8-35.6
      s-25.5-49.6-28.8-53c-3.4-3.4-26.8-36.2-28.8-37.6c-2-1.3-18.1-20.1-20.1-22.8c-2-2.7-26.8-16.1-33.5-18.8
      c-6.7-2.7-30.9-9.4-36.9-12.1c-6-2.7-27.5-5.4-31.5-5.4c-4,0-23.5-0.7-28.2,0s-36.9,5.4-41.6,5.4c-4.7,0-26.8-0.7-33.5,2
      c-6.7,2.7-23.5,8.7-23.5,8.7s-24.8,12.1-26.8,13.4c-2,1.3-20.8,12.7-23.5,15.4s-14.1,14.1-18.8,18.1c-4.7,4-18.8,16.1-24.8,20.1
      c-6,4-33.5,32.9-33.5,32.9s-25.5,22.1-27.5,24.8s-20.1,25.5-20.8,28.2c-0.7,2.7-22.8,38.2-23.5,40.2S73.5,288.2,72.1,303
      s-1.3,18.1,0,26.2c1.3,8,0,27.5,3.4,39.6c3.4,12.1,6,15.4,6.7,28.2c0.7,12.7-0.7,26.2-0.7,26.2s4,15.4,6,20.1s5.4,16.1,6,18.1
      c0.7,2,0,14.8,0,14.8"
          />
        </g>
        <g id="Base" v-show="base">
          <path
            d="M94.3,470.7c0,0,42.9,24.8,44.3,26.8s54.3,9.4,54.3,9.4s66.4,3.4,70.4,4s57.7,2.7,62.4,4s51.7,20.1,51.7,20.1
      s22.8,4.7,28.8,8.7s49.6,24.8,53.7,29.5c4,4.7,25.5,31.5,25.5,31.5s30.9,38.9,35.6,45.6c4.7,6.7,26.8,28.2,32.9,35.6
      c6,7.4,24.8,25.5,27.5,28.8c2.7,3.4,15.4,15.4,24.1,27.5c8.7,12.1,40.2,34.9,40.2,34.9s0,0-8.3,2.9c-1.9,0.7-42-24.4-42-24.4
      S545,714.2,539,711.5s-38.9-26.8-53.7-46.3c-14.8-19.5-39.6-47-51.7-55s-32.5-20.8-33.7-24.1c-1.2-3.4-1.9-16.1-6.6-17.4
      s-29.5-13.4-29.5-13.4s-16.8,2-18.8,2.7c-2,0.7-15.4-2-15.4-2s-16.1-6.7-21.5-4.7c-5.4,2-12.1,5.4-12.1,5.4l-30.9,2.7l-16.8-2.7
      l-23.5-4c0,0-28.8-21.5-38.2-24.1c-9.4-2.7-32.2-5.4-34.9-5.4c-2.7,0-24.1,0.7-24.1,0.7L109,501.5l-21.5-17.4L94.3,470.7z"
          />
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "ScaleAnatomy",
  props: {
    small: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      margin: false,
      base: false,
      focus: false,
      anterior: false,
      posterior: false,
    };
  },
  methods: {
    ShowHide(which) {
      switch (which) {
        case 'margin':
          this.margin = !this.margin;
          break;

        case 'base':
          this.base = !this.base;
          break;

        case 'focus':
          this.focus = !this.focus;
          break;

        case 'posterior':
          this.posterior = !this.posterior;
          break;

        case 'anterior':
          this.anterior = !this.anterior;
          break;
      
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.__scale_anatomy {
  width: 75%;
  // margin: 0 auto;

  svg {
    border-radius: 30px;
    box-shadow: 3px 3px 6px #00000030;
  }

  // #Annular1 {
  //   opacity: 0.44;
  //   fill: transparent;

  //   &:hover {
  //     fill: red;
  //   }
  // }

  #Posterior {
    opacity: 0.5;
    fill: #ed1c24;
  }
  #Anterior {
    opacity: 0.5;
    fill: #3f983f;
  }
  #Focus {
    opacity: 0.5;
    fill: #b505fa;
  }
  #Margin {
    opacity: 0.5;
    fill: none;
    stroke: #f7aa05;
    stroke-width: 15;
    stroke-miterlimit: 10;
  }
  #Base {
    opacity: 0.5;
    fill: #00aeef;
  }

  .margin {
    background-color: #f7aa0590 !important;
    color: white;
    h4 {
      color: white;
    }
  }

  .focus {
    background-color: #b505fa80 !important;
    color: white;
    h4 {
      color: white;
    }
  }

  .base {
    background-color: #00aeef80 !important;
    color: white;
    h4 {
      color: white;
    }
  }

  .anterior {
    background-color: #3f983f80 !important;
    color: white;
    h4 {
      color: white;
    }
  }

  .posterior {
    background-color: #ed1c2480 !important;
    color: white;
    h4 {
      color: white;
    }
  }

  .item {
    margin: 10px 0px;
    background-color: #efefef;
    padding: 15px;
    border-radius: 10px;
    cursor: pointer;
    font-weight: 500;

    h4 {
      font-size: 20px;
      margin: 2px 0px;
    }

    p {
      font-size: 15px;
      margin: 0px;
    }
  }

  .instruction {
    font-size: 12px;
    color:#777;
    margin: 0px;
  }

  .small {
    h4 {
      font-size: 16px;
      margin: 2px 0px;
    }

    p {
      font-size: 12px;
      margin: 0px;
    }
  }

  ul {
    list-style-type: circle;
    margin: 0;
    padding: 0;

    li {
      margin: 0 0 0 30px;
      padding: 0;
    }
  }

}
</style>